/**
 * Small helper to delay an execution
 */
export default function delay(duration: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), duration);
  });
}
